<template>
  <div id="app">
    <keep-alive :include="$store.state.keepAliveInclude">
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>

    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
  import { removeLaunchImage, getLocation } from './libs/native-app';

  export default {
    name: 'App',
    data() {
      return {
        timer: null
      };
    },
    async mounted() {
      // 检查是否有待恢复的返回路径（从 PDF 页面返回，仅小程序环境）
      const isMiniProgram = typeof window !== 'undefined' && 
        (window.__wxjs_environment === 'miniprogram' || 
        (navigator.userAgent && navigator.userAgent.toLowerCase().indexOf('miniprogram') > -1));
      
      if (isMiniProgram) {
        const pdfReturnData = localStorage.getItem('pdfReturnPath');
        if (pdfReturnData) {
          localStorage.removeItem('pdfReturnPath');
          try {
            const { path, timestamp } = JSON.parse(pdfReturnData);
            // 只在30秒内有效
            if (path && timestamp && (Date.now() - timestamp) < 30000) {
              console.log('检测到 PDF 返回路径，跳转到:', path);
              this.$router.replace(path);
            }
          } catch (e) {
            console.log('解析 pdfReturnPath 失败:', e);
          }
        }
      }
      
      window.ssqSignFinishedCallback = () => {
        this.$loading();
        this.$store.commit('updateToHome', true);
        this.$router.replace('home');
        this.$loadingClose();
      };
      try {
        await removeLaunchImage();
        let res = await getLocation();
        this.$store.commit('updatePos', res);
      } catch (e) {
        console.log(e.message);
      }
      // 获取服务端最新的H5版本，定期检查前端代码是否有更新，有更新就自动刷新页面加载新版本。
      // if (!this.timer) await this.getH5Ver();
    },
    watch: {
      $route(to, from) {
        let include = this.$store.state.keepAliveInclude;
        if (to.meta.keepAlive) {
          !include.includes(to.name) && include.push(to.name);
        }
        if ((to.meta.deepth || 0) <= from.meta.deepth) {
          let index = include.indexOf(from.name);
          index !== -1 && include.splice(index, 1);
        }
        this.$store.commit('updateKeepAliveInclude', include);
      }
    },
    methods: {
      async getH5Ver() {
        try {
          this.timer = setInterval(async () => {
            let result = await this.$store.dispatch('postData', {
              url: '/common/CheckVer',
              data: {},
              need_sign: false
            });
            if (this.$store.state.h5Ver && result !== this.$store.state.h5Ver) {
              location.reload();
            }
            this.$store.commit('updateH5Ver', result);
          }, 30000);
        } catch (e) {
          this.$error(e.message);
        }
      }
    }
  };
</script>
